import TaskRunner from './base/TaskRunner';
// const breakpoints = require('./base/breakpoints');

// breakpoints.regBreakpoint('medium', 768);
// breakpoints.regBreakpoint('big', 1200);

// breakpoints.start();

import './tasks/others';
import './tasks/header';

import './tasks/accordion';
import './tasks/swiper';
// import './tasks/fancybox';
// import './tasks/smoothScroll';
// import './tasks/tippy';
// import './tasks/youtube';
import './tasks/customFocus';
import './tasks/popups';
import './tasks/tabs';
import './tasks/forms';
import './tasks/rellax';
import './tasks/nouislider';
// import './tasks/fslightbox';
// import './tasks/pseudoselect';
import './tasks/scrollAnimations';
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

import './tasks/body';
import axios from "axios";
/*import * as moment from "moment";*/
import IMask from 'imask'

import {LogClient} from "./tasks/LogClient";

window.IMask = IMask;

window.message = ({message = null}) => {
    if (message) {
        document.getElementById('messageText'). innerHTML = message
        Popup.getObject('#messagePopup').show()
    }
}

window.errorMessage = ({message = null}) => {
    if (message) {
        document.getElementById('errorMessageText'). innerHTML = message
        Popup.getObject('#errorMessagePopup').show()
    }
}
document.addEventListener('DOMContentLoaded', () => {
    window.TaskRunner = TaskRunner;
    TaskRunner.add(() => {
        document.dispatchEvent(new CustomEvent('AppLoaded'));
    })
    TaskRunner.run();
});


document.addEventListener('DOMContentLoaded', function (e) {

    setTimeout(function () {
        let interval = setInterval(async function () {
            try {
                let url = window.session_uid ? `/main/ping?uid=${window.session_uid}` : '/main/ping';

                let resp = await axios.get(url);
                if (resp.status === 200 && resp.data) {
                    if (window.session_uid) { // если был авторизован

                        if (!resp.data.uid) { // а теперь нет - отправляем авторизовываться
                            clearInterval(interval)
                            return location.href = '/auth/login';
                        }
                    }

                    if (resp.data.uid && !window.session_uid) {
                        window.session_uid = resp.data.uid;
                    }

                }
            } catch (e) {

            }
        }, 60000)


        let logOut = document.querySelector('.header-logout');
        if (logOut) {
            logOut.addEventListener('click', async () => {
                const preloader = document.getElementById('preloader');
                preloader.classList.add("show");
                try {
                    await axios.post('/auth/logout');
                } catch (e) {
                    preloader.classList.remove("show");
                }

                document.location.href = '/';
            })
        }
    }, 100)


    if (navigator.userAgent.toLowerCase().search(/android/) !== -1) {
        let showChat = () => {
            let chatButton = document.getElementById('chat21-launcher-button');
            if (!chatButton) return;

            chatButton.classList.remove('d-none');
        };
        let hideChat = () => {
            let chatButton = document.getElementById('chat21-launcher-button');
            if (!chatButton) return;

            chatButton.classList.add('d-none');
        }

        let checkAndShowMobile = (interval) => {
            let noticeShowed;
            try {
                noticeShowed = sessionStorage.getItem('mobileNoticeShowed') === 'true';
            } catch (e) {
                noticeShowed = false;
            }

            let cookieNotice = document.getElementById('cookieNotice');
            let mobileNotice = document.getElementById('mobileNotice');
            let isApplicationForm = /\/application/.test(location.pathname);

            if (!cookieNotice || !mobileNotice || noticeShowed || isApplicationForm) {
                return false;
            }
            if (getComputedStyle(cookieNotice).display === 'none') {
                mobileNotice.classList.remove('d-none');
                hideChat();
                clearInterval(interval)
            }

        }

        let mobileNoticeClose = document.getElementById('mobileNoticeClose');
        let mobileNoticeLink1 = document.getElementById('mobileNoticeLink1');
        let mobileNoticeLink2 = document.getElementById('mobileNoticeLink2');
        let mobileNotice = document.getElementById('mobileNotice');

        if (mobileNoticeLink1) {
            mobileNoticeLink1.addEventListener('click', function () {
                try {
                    mobileNotice.classList.add('d-none');
                    showChat()
                    sessionStorage.setItem('mobileNoticeShowed', 'true');
                } catch (e) {
                }
            })
        }

        if (mobileNoticeLink2) {
            mobileNoticeLink2.addEventListener('click', function () {
                try {
                    mobileNotice.classList.add('d-none');
                    showChat()
                    sessionStorage.setItem('mobileNoticeShowed', 'true');
                } catch (e) {
                }
            })
        }
        if (mobileNoticeClose) {
            mobileNoticeClose.addEventListener('click', function () {


                if (!mobileNotice) {
                    return false;
                }

                mobileNotice.classList.add('d-none');
                showChat()
                try {
                    sessionStorage.setItem('mobileNoticeShowed', 'true');
                } catch (e) {

                }
            })
        }
        let interval = setInterval(function () {
            checkAndShowMobile(interval);
        }, 3000)
    }

    window.LogClient = new LogClient();
    try {
        window.LogClient.init();

        document.addEventListener('click', event => {
            try {
                if (event.target.name || event.target.id) {
                    let targetName = event.target.name || event.target.id;
                    window.LogClient.sendEvent('click', targetName);
                }
            } catch (e) { }
        })
    } catch (e) {
        //console.log('err', e)
    }


})